import styled, { css } from 'styled-components';

import { Flexer } from '@ontruck/orc';

const overflowProps = () =>
  css`
    overflow: hidden;
    overflow-y: auto;
    &::-webkit-scrollbar {
      width: 6px !important;
      height: 6px !important;
      border-radius: 6px !important;
    }

    &::-webkit-scrollbar-thumb {
      background-color: rgba(56, 62, 66, 0.5);
    }

    &::-webkit-scrollbar-track {
      background: rgba(255, 255, 255, 0);
    }
  `;

export default styled(Flexer.Parent).attrs(() => ({ flexDirection: 'column' }))`
  ${overflowProps};
`;
